import { compose, hoistStatics } from 'recompose';
import Button from './button';

const enhance = compose();
export default hoistStatics(enhance)(Button);
